import { Component, ElementRef, HostListener, ViewChild, AfterViewInit } from '@angular/core';
import { HeaderService } from '../../services/headerservice';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements AfterViewInit {

	@ViewChild("header") header! : ElementRef;
	@HostListener('window:resize')
	onResizeHandler(): void {
		this.headerService.emitHeight(this.header.nativeElement.offsetHeight);
	}

	constructor(private headerService:HeaderService) { }

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.headerService.emitHeight(this.header.nativeElement.offsetHeight);
		}, 0);
	}
}